import React from 'react';
import { useState } from 'react';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';

import config from "../config.json";

import "../css/homepage/normalize.css";
import "../css/homepage/webflow.css";
import "../css/homepage/usb-mainsite.webflow.css";

import logo from '../images/UniSafeBox_Logo.png';
import biofiToken from '../images/BioFi-Token_Wht_transparent.svg';


const isEmail = (email) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export default function RequestLink() {
  const [emailAddress, setEmailAddress] = useState('');
  const [emailValid, setEmailValid] = useState(false);
  const [emailAlreadySent, setEmailAlreadySent] = useState(false);

  function emailChange(event) {
    let email = event.target.value;
    let isEmailValid = (email.length > 0) && isEmail(email);
    setEmailAddress(email);
    setEmailValid(isEmailValid);
  }

  async function requestSubmit(event) {
    console.log('Request for user: ' + emailAddress);

    toast("Requesting a payment link...");

    event.preventDefault();

    let requestUrl = 'https://usb-payment-api-test.fnvt.net/usbapi/sendEmail?EmailAddress=' + emailAddress + '&APIKey=' + config.API_KEY;

    const response = await fetch(requestUrl, {
      method: 'POST',
      mode: 'cors',
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    });

    if (!response.ok) {
      toast.error('Sending email failed');
      alert('Failed to send email. Are you using the correct email address?');
      console.error("[setUserAddress] " + response.status + " code detected. Request failed.");
      //setUpdateUserFinished(false);
      return;
    }

    const jsonResponse = await response.json();

    toast.success('Check your inbox');
    setEmailAlreadySent(true);
    console.log(jsonResponse.msg);
  }

  return (
    <>
    {/*Header Navbar */}
      <div className="page-wrapper">
        <div data-collapse="medium"
          data-animation="over-right"
          data-duration={400}
          data-w-id="58db7844-5919-d71b-dd74-2323ed8dffe9"
          data-easing="ease"
          data-easing2="ease"
          role="banner"
          className="header w-nav"
        >
          <div className="container-default w-container">
            <div className="header-wrapper">
              <div
                data-w-id="a3e68005-48fe-fa9e-c964-745ec27593aa"
                className="split-content header-right"
              >
                <Link to="/" className="header-logo-link w-nav-brand">
                  <img
                    src={require("../images/UniSafeBox_Logo.png")}
                    alt=""
                    className="header-logo-2"
                  />
                </Link>
              </div>
              
              <div>
                  <input type="checkbox" id="menu-toggle" />
                  <label for="menu-toggle" class="hamburger-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </label>
                  <nav id="mobile-nav">
                  <ul role="list" className="header-navigation">
                    <li className="nav-item-wrapper first">
                      <Link to="/" className="nav-link-2">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item-wrapper">
                      <Link to="/requestLink" className="nav-link-2">
                        Pay for USB
                      </Link>
                    </li>
                    <li className="nav-item-wrapper header-button-wrapper">
                      <div className="nav-button-wrapper">
                        <a
                          href="https://finnovant.s3.amazonaws.com/UniSafeBox-Android.apk"
                          className="button-primary-2 full-width w-button"
                        >
                          Download Now
                        </a>
                      </div>
                    </li>
                  </ul>
                  </nav>
                </div>
              
              <div className="split-content header-left">
                <div className="nav-button-wrapper hide-in-mobile">
                  <a href="https://finnovant.s3.amazonaws.com/UniSafeBox-Android.apk" className="button-primary-2 small w-button">
                    Download Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*Body Start*/}
        <section className="section-2 wf-section">
          <div className="usb_payinner">
            <div>
              <h2 className="heading-2">UniSafeBox - Payment Link Request</h2>
            </div>
            <div className="usb_paymentproc">
            <div className="div-block-2">
            <img src={biofiToken} loading="lazy" alt="" className="image-12" />
            <p class="paragraph-2">Enter the email address you used for creating your UniSafeBox account.</p>
            </div>
            <div className="form-block w-form">
            <form onSubmit={requestSubmit} className="form">
            <label for="email" class="field-label-2">Email Address</label>
            <input type="email" value={emailAddress} onChange={emailChange} className="text-field w-input" />
              <button disabled={!emailValid || emailAlreadySent} className="btn-purchase">{emailAlreadySent ? 'Already sent' : 'Send payment link'} </button>
              </form>

          </div>
      </div>
    </div>
  </section>
        </div>
        
      <footer className="footer">
          <div className="container-default">
            <div className="w-layout-grid footer-grid">
              <div
                id="w-node-_545d2dbf-8143-2662-0998-a356a1027525-ae2f46c5"
                className="footer-column"
              >
                <a
                  href="#"
                  className="footer-logo-container mg-bottom-24px w-inline-block"
                >
                  <img
                    src={require("../images/UniSafeBox_Logo.png")}
                    alt=""
                    className="footer-logo"
                  />
                </a>
                <p className="mg-bottom-32px">
                  Secure your assets with UniSafeBox Powered Biometric
                  Financial.
                  <br />
                </p>
                <div className="social-links-wrapper" />
              </div>
              <div
                id="w-node-_8f0dde0c-ad87-3903-db5c-1a8dc74f8208-ae2f46c5"
                className="footer-column middle"
              >
                <div className="footer-nav-main-wrapper">
                  <div className="footer-nav-wrapper">
                    <ul role="list" className="footer-nav" />
                  </div>
                </div>
              </div>
            </div>
            <div className="divider bg-neutral-600" />
            <div className="footer-bottom-content">
              <div>
                Copyright © 2023 UniSafeBox - powered by <a href="https://www.biometricfinancial.org" alt="Biofi">Biometric Financial</a> 
              </div>
            </div>
          </div>
        </footer>
    </>
  );

}